import * as React from 'react';

const PencilSvg = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7486 5.46333L14.5367 4.25135C14.2015 3.91622 13.659 3.91622 13.3247 4.25135L4.25114 13.3249C4.09 13.4852 4 13.7038 4 13.9309V16H6.06911C6.29624 16 6.51481 15.91 6.6751 15.7489L15.7486 6.67531C16.0838 6.34103 16.0838 5.79847 15.7486 5.46333V5.46333Z"
      stroke={props.color || '#CCCCCC'}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.2081 8.20836L11.791 5.79126"
      stroke={props.color || '#CCCCCC'}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PencilSvg;
